import { render, staticRenderFns } from "./CardOverview.vue?vue&type=template&id=c3edd044&scoped=true&"
import script from "./CardOverview.vue?vue&type=script&lang=ts&"
export * from "./CardOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CardOverview.vue?vue&type=style&index=0&id=c3edd044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3edd044",
  null
  
)

export default component.exports